import { ReactComponent as ICON1 } from '@/assets/about/icon1.svg'
import { ReactComponent as ICON2 } from '@/assets/about/icon2.svg'
import { ReactComponent as ICON3 } from '@/assets/about/icon3.svg'

import Footer from '@/components/Footer'
import { tokens } from './init'
import { useTranslation } from 'react-i18next'
import { useEffect, useMemo } from 'react'

import { ReactComponent as BG_BLACK } from '@/assets/help/help-top-bg-black.svg'
import BOTTOM from '@/assets/help/help-bottom-bg.png'
import BG from '@/assets/about/about-top-bg.png'
import BG_TWO from '@/assets/about/about-two-top-black.png'
import { ReactComponent as BG_TWO_RIGHT } from '@/assets/about/about-two-right-bg.svg'
import THREE_CENTER from '@/assets/about/about-three-top-bg.png'
import FOUR_BG from '@/assets/about/about-four-bg.png'

import { ReactComponent as ONE } from '@/assets/about/01.svg'
import { ReactComponent as TWO } from '@/assets/about/02.svg'
import { ReactComponent as THREE } from '@/assets/about/03.svg'
import { ReactComponent as FOUR } from '@/assets/about/04.svg'
import AutoScrollLoop from './AutoScrollLoop'

const superior = [
	{ icon: <ICON1 />, title: 'about.title2.tips1' },
	{ icon: <ICON2 />, title: 'about.title2.tips2' },
	{ icon: <ICON3 />, title: 'about.title2.tips3' },
]

export default function About() {
	const { t } = useTranslation()

	useEffect(() => {
		window.scrollTo(0, 0)
	}, [])

	const itemsArrs = useMemo(() => {
		return [
			[...tokens.filter((item, key) => key < 15)],
			[...tokens.filter((item, key) => key >= 15 && key < 30)],
			[...tokens.filter((item, key) => key >= 30 && key < 45)],
			[...tokens.filter((item, key) => key >= 45)],
		]
	}, [])

	return (
		<div className="h-full overflow-hidden overflow-y-scroll pt-4 sm:pt-[3.875rem]">
			<img src={BG} className="absolute -top-[4.5rem] left-0 z-[1] h-auto w-full sm:top-0 sm:rounded-t-2xl" alt="" />
			<BG_BLACK className="absolute -top-[4.5rem] left-0 z-[2] h-auto w-full sm:top-0 sm:rounded-t-2xl" />
			<img src={BOTTOM} alt="" className="absolute bottom-0 left-0 z-[1] h-auto w-full" />

			<div className="relative z-10 w-full">
				<div className="w-full py-5">
					<div className="relative flex min-h-[5.625rem] w-full items-center justify-center">
						<div className="tail-text-menu z-10 text-center text-4xl">{t('about.title')}</div>
						<ONE className="absolute z-[1]" />
					</div>
				</div>

				<div className="relative z-10 flex items-start gap-4 px-10 pb-6 pt-4">
					<p className="text-[0.9375rem] leading-normal text-white">{t('about.content')}</p>
				</div>

				<div className="relative w-full pb-10 pt-5">
					<img src={BG_TWO} className="absolute -top-16 left-0 z-0 h-[7.375rem] w-full" alt="" />
					<div className="relative flex min-h-[5.625rem] w-full items-center justify-center">
						<div className="tail-text-menu z-10 text-center text-4xl">{t('about.title2')}</div>
						<TWO className="absolute z-[1]" />
					</div>
				</div>

				<div className="relative grid grid-cols-2 gap-4 px-4">
					<BG_TWO_RIGHT className="absolute -top-14 right-0 z-0" />
					{superior.map((item, index) => (
						<div className="relative z-10 min-h-[7.625rem] rounded-[2rem] px-4 py-10" key={index}>
							{item.icon}
							<div className="tail-about-superior"></div>
							<div className="mt-4 text-[0.625rem] text-white">{t(item.title)}</div>
						</div>
					))}
				</div>

				<div className="relative w-full pb-5 pt-10">
					<div className="relative z-10 flex min-h-[5.625rem] w-full items-center justify-center">
						<div className="tail-text-menu z-10 text-center text-4xl">{t('about.title3')}</div>
						<THREE className="absolute z-[1]" />
					</div>
					<div className="absolute left-[calc(50%_-_10rem)] top-0 z-0">
						<img src={THREE_CENTER} className="h-auto w-[20rem]" alt="" />
					</div>
				</div>
				<div className="relative z-10 px-5 text-base text-white">{t('about.title3.tips1')}</div>

				{/* <div className="tail-text-menu px-4 text-2xl font-bold">{t('about.title4')}</div> */}

				<div
					className="relative w-full pb-5 pt-10"
					style={{
						background: `url(${FOUR_BG})`,
						backgroundSize: '100% 100%',
					}}
				>
					<div className="relative z-[2] flex w-full items-center justify-center">
						<FOUR className="opacity-80" />
					</div>
					{itemsArrs.map((tokens, index) => (
						<AutoScrollLoop toRight={index % 2 === 0 ? true : false} key={index} items={tokens} />
					))}
				</div>

				<Footer />
			</div>
		</div>
	)
}
